export const textIconStyle = {
  color: '#747474',
  alignSelf: 'flex-start',
}
